export default __webpack_public_path__ + "avenir_white-de11d7ce4d80561ed31cd9ec860ac222.xml";